<kendo-dialog class="preview-dashboard" *ngIf="dialogOpened">
    <div class="preview-container" [ngClass]="{'position-loading': loading}">
        <ng-container *ngIf="screenType!=='URL'">
            <div class="print-hide print-operate">
                <button tam-button tamType="primary" tamSize="normal" (click)="printPage()">Print</button>
                <smart-icon class="light dialog-close" name="close" (click)="closeDialog()">
                </smart-icon>

            </div>
            <div class="print-hide print-tip">
                <span>Tip:</span>
                <span>If your data does not fit on the page, you can adjust it using the scale and margin options found
                    in
                    the system dialog by clicking "Print" above.</span>
            </div>
        </ng-container>
        <div class="gridster-loading" [hidden]="!loading">
            <div class="loading-div" loading-spin [isLoading]="loading" [loadingSize]="'big'"></div>
        </div>
        <div class="gridster">
            <button class="hidden-btn print-hide" *ngIf="isGridTileIncluded" type="button" id="excelexport"
                (click)="triggerAllXLSExport($event)">export
                excels</button>
            <ng-container *ngFor="let item of gsItems;let i = index;">
                <div class="gs-item" [ngClass]="breakPageClass(item, i)" [ngStyle]="getStyle(item)">
                    <ng-container *ngIf="item.type !== null">
                        <tam-print-tile-container [gsItem]="item" [feedbackSubject$]="feedbackSubject$">
                        </tam-print-tile-container>
                    </ng-container>
                </div>
            </ng-container>
        </div>
    </div>
</kendo-dialog>
<kendo-popup *ngIf='popUpParams.showAxisToolTip' [anchor]='popUpParams.popupAnchor'>
    {{popUpParams.popupContent}}
</kendo-popup>
<div *ngIf="renderDashboardReadyForServer" id="renderDashboardReady"></div>